<template>
    <div class="checkbox">
        <label>
            <input
                type="checkbox"
                :disabled="!enabled"
                :checked="controlValue.data"
                @change="onChange"
            />
            {{ controlValue.label }}
        </label>
    </div>
</template>

<script>
import { useJsonFormsControl } from "@jsonforms/vue2";

export default {
    name: "CheckboxRenderer",
    props: {
        schema: {
            required: true,
            type: [Object, Boolean]
        },
        uischema: {
            required: true,
            type: Object
        },
        path: {
            required: true,
            type: String
        },
        enabled: {
            required: false,
            type: Boolean,
            default: undefined
        },
        renderers: {
            required: false,
            type: Array,
            default: undefined
        },
        cells: {
            required: false,
            type: Array,
            default: undefined
        },
        config: {
            required: false,
            type: Object,
            default: undefined
        }
    },
    setup(props) {
        const { control, handleChange } = useJsonFormsControl(props)

        return {
            controlValue: control,
            onChange(event) {
                handleChange(control.value.path, event.target.checked)
            },
        };
    },
};
</script>
